import React from 'react';
import ReactDOM from 'react-dom/client';
import { loadConfig } from './config';
import { ConfigErrorScreen } from './components/ConfigErrorScreen';

/**
 * Loads /config.json before React renders the app (design §3.4 step 1, §7.2). If the
 * config can't be loaded, renders a static error instead of a half-configured app.
 */
export async function bootstrap(
  container: HTMLElement,
  fetchImpl: typeof fetch = fetch,
): Promise<'app' | 'error'> {
  const root = ReactDOM.createRoot(container);
  try {
    await loadConfig(fetchImpl);
  } catch (err) {
    console.error('Failed to load runtime config', err);
    root.render(<ConfigErrorScreen />);
    return 'error';
  }
  // Imported after the config is loaded so no module reads it too early.
  const { default: App } = await import('./App');
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
  return 'app';
}
